import ReactPlayer from "react-player";

/**
 * Overrides ReactPlayer's getCurrentTime to return times within startTime and endTime bounds.
 * This prevents bugs caused by out of bounds times during transitional periods.
 */
const NATIVE_GET_CURRENT_TIME = "__nativeGetCurrentTime";
const NATIVE_SEEK_TO = "__nativeSeekTo";

export function applyPlaybackRate(player: ReactPlayer, playbackRate: number) {
  const internal = player.getInternalPlayer();
  if (
    internal != null &&
    typeof internal === "object" &&
    "playbackRate" in internal
  ) {
    (internal as HTMLMediaElement).playbackRate = playbackRate;
  }
}

export function applyPlayerOverrides(
  player: ReactPlayer,
  startTime: number,
  endTime?: number,
  playbackRate?: number,
) {
  function _seekTo(time: number) {
    if (time < startTime) time = startTime;
    else if (endTime != undefined && time > endTime) time = endTime;

    // Always "seconds" — ReactPlayer treats bare values in (0, 1) as fractions.
    // FilePlayer.seekTo already writes internal.currentTime; do not stamp it
    // again here (a second, unguarded write is a parallel seek path).
    player[NATIVE_SEEK_TO](time, "seconds");
  }

  function _getCurrentTime() {
    const currentTime = player[NATIVE_GET_CURRENT_TIME]();

    if (currentTime < startTime) {
      _seekTo(startTime);
      return startTime;
    }

    return currentTime;
  }

  if (!(NATIVE_GET_CURRENT_TIME in player)) {
    player[NATIVE_GET_CURRENT_TIME] = player.getCurrentTime;
    player.getCurrentTime = _getCurrentTime;
  }

  if (!(NATIVE_SEEK_TO in player)) {
    player[NATIVE_SEEK_TO] = player.seekTo;
    player.seekTo = _seekTo;
  }

  if (playbackRate != null) {
    applyPlaybackRate(player, playbackRate);
  }
}
